import { useHistory, useLocation } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";

const TABS = {
  connections: "/members/connections",
  allMembers: "/members",
};

export const TabNavigation = ({ className }: { className?: string }) => {
  const { pathname: currentPathname } = useLocation();
  const history = useHistory();

  const options = [
    {
      value: TABS.connections,
      label: t("members_directory.tab_navigation.connections"),
    },
    {
      value: TABS.allMembers,
      label: t("members_directory.tab_navigation.all_members"),
    },
  ];

  const activeTab =
    currentPathname === TABS.connections ? TABS.connections : TABS.allMembers;

  const handleTabChange = (value: string) => {
    history.push(value);
  };

  return (
    <div className={classNames("flex items-center gap-6", className)}>
      <nav className="flex gap-1">
        {options.map(option => (
          <button
            type="button"
            key={option.value}
            onClick={() => handleTabChange(option.value)}
            className={classNames(
              "rounded-full px-4 py-2 text-sm font-medium transition-colors",
              activeTab === option.value
                ? "bg-secondary"
                : "text-default hover:bg-secondary/10 hover:text-dark",
            )}
          >
            {option.label}
          </button>
        ))}
      </nav>
    </div>
  );
};
